import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useUnreadMessages(user) {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!user || user === false) {
      setUnread(0);
      return;
    }
    let stop = false;
    const fetchCount = async () => {
      try {
        const { data } = await api.get("/messages/unread-count");
        if (!stop) setUnread(data.unread || 0);
      } catch { /* ignore */ }
    };
    fetchCount();
    const t = setInterval(fetchCount, 15000);
    return () => { stop = true; clearInterval(t); };
  }, [user]);

  return unread;
}
